//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        rule_link () {
            console.error(this.attachs)
            if (this.attachs) {
                return this.attachs.rule || this.attachs.registration_rule_url || ''
            }
            return ''
        },
        is_price_diagram () {
            return this.price_diagram && this.price_diagram.diagram_url
        },
        show_lpd () {
            return this.checkStatus('lpd')
        },
    },
    methods: {
        openPriceGraph (e) {
            if (this.is_price_diagram) {
                this.$router.push({
                    path: `/building/price?house_id=${this.house_id}&building_id=${this.building_id}`
                })
            }
        },
        openRule (e) {
            if (this.attachs.rule) {
                this.openDoc(e)
            }
        },
        openDoc (e) {
            this.$emit('tabLog', e)
            this.download(e)
        },
        download (e) {
            const { url } = e.target.dataset
            if (!url) {
                return
            }
            this.$wx.showLoading()
            if (url.search(/\.(png|jpg|jpeg|gif|bmp)/) > -1) {
                this.$wx.previewImage({
                    current: url,
                    urls: [url],
                })
                this.$wx.hideLoading()
                return
            }
        },
        handleError (err) {
            this.$wx.hideLoading()
            console.error(err)
        },
        goReview (e) {
            this.$emit('tabLog', e)
            if (this.lrd_status === 'lrd_completed') {
                const { building_id } = this.$route.query
                this.$router.push({
                    path: `/building/result?building_id=${building_id || ''}&house_id=${this.house_id || ''}&name=${this.name}&type=reg`
                })
            }
        },
        goResult (e) {
            this.$emit('tabLog', e)
            if (this.lfd_status === 'lfd_completed') {
                const { building_id } = this.$route.query
                this.$router.push({
                    path: `/building/result?building_id=${building_id || ''}&house_id=${this.house_id || ''}&name=${this.name}&type=result`
                })
            }
        },
        golpd (e) {
            this.$emit('tabLog', e)
            const { building_id } = this.$route.query
            this.$router.push({
                path: `/building/result?house_id=${this.house_id || ''}&building_id=${building_id || ''}&name=${this.name}&type=lpd`
            })
        },
        checkStatus(type) {
            return this.current_house[`${type}_status`] === `${type}_completed`
        }
    },
    props: {
        attachs: {
            type: Object,
            default: () => ({}),
            required: true
        },
        lrd_status: {
            type: String
        },
        lfd_status: {
            type: String
        },
        building_id: {
            type: [String, Number]
        },
        house_id: {
            type: [String, Number]
        },
        name: {
            type: String
        },
        price_diagram: {
            type: Object
        },
        current_house: {
            type: Object
        }
    }
}
